const GEO_LOCATION_TAG_TYPES = {
    GEO_LOCATION_GET_SECTORS: "GEO_LOCATION_GET_SECTORS",
    // GEO_LOCATION_CREATE: "GEO_LOCATION_CREATE", 
    // GEO_LOCATION_EDIT: "GEO_LOCATION_EDIT",
    // GEO_LOCATION_DETAIL: "GEO_LOCATION_DETAIL",
    // GEO_LOCATION_CHECK_CONFLICT: "GEO_LOCATION_CHECK_CONFLICT"
  };
  
  export const GEO_LOCATION_TAGS = Object.values(GEO_LOCATION_TAG_TYPES);
  export default GEO_LOCATION_TAG_TYPES;
  